import React from 'react';
import { Tag } from '@bedrock/components';

const OA_STATUS_CONF = {
  NOT_SUBMITTED: { text: '未提交', color: 'light-brand' },
  SUBMITTING: { text: '提交中', color: 'light-orange' },
  SUBMITTED: { text: '已提交', color: 'light-blue' },
  REJECTED: { text: '已驳回', color: 'light-red' },
  ARCHIVING: { text: '已归档', color: 'light-green' },
}

export default function OAStatusTag({ status }) {
  if (!status || 'NOT_SUBMITTED_OTHER' === status) return '--';
  return <Tag text={OA_STATUS_CONF[status]?.text} size={'small'} color={OA_STATUS_CONF[status]?.color} />;
}